import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './muitable.module.css';
import Pagination from '../Pagination/Pagination';
import { SortOrderType } from '../../config/enum';
import ViewData from './ViewData';
import { colors } from '../../config/constants';
export interface Column {
  id: string | number;
  label: string;
  minWidth?: number;
  align?: any;
}

interface MuiTableProps {
  columns: Column[];
  rows: any;
  onViewHandler?: (arg: string | number) => void;
  onSortHandler?: (arg: string | number) => void;
  onDeleteHandler?: (arg: string | number) => void;
  onEditHanlder?: (arg: string | number) => void;
  onSrcFileDownload?: (arg: string | number) => void;
  onErrFileDownload?: (arg: string | number) => void;
  onMarkForArchived?: (arg: string | number) => void;
  sortOrder: string;
  page: number;
  limit: number;
  paginateHandler?: any;
  totalRowCount: number;
  checkBoxValue?: string;
  checkBoxShow?: boolean;
  showDelete?: boolean;
  showEdit?: boolean;
  showView?: boolean;
}

const MuiTable = (props: any) => {
  const {
    columns,
    rows,
    onViewHandler,
    onSortHandler,
    onDeleteHandler,
    onEditHanlder,
    onSrcFileDownload,
    onErrFileDownload,
    sortOrder,
    page,
    limit,
    paginateHandler,
    totalRowCount,
    checkBoxValue,
    checkBoxShow,
    showDelete,
    showEdit,
    showView,
    onMarkForArchived,
    sortArray,
  } = props;
  const [state, setState] = useState<any>([]);
  const [isSelected, setIsSelected] = useState<any>([]);
  const [columnId, setColumnId] = useState('');
  const tableElement = document.getElementById('table-row');

  useEffect(() => {
    setState(rows);
    handleTableHeader(columns);
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: 'smooth' });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [rows]);

  const showItem = (value: string, column: Column, row: any) => {
    return (
      <ViewData
        value={value}
        column={column}
        row={row}
        showView={showView}
        showEdit={showEdit}
        showDelete={showDelete}
        onViewHandler={onViewHandler}
        onDeleteHandler={onDeleteHandler}
        onEditHanlder={onEditHanlder}
        onSrcFileDownload={onSrcFileDownload}
        onErrFileDownload={onErrFileDownload}
        onMarkForArchived={onMarkForArchived}
      />
    );
  };
  const handleTableHeader = (columnObj: Column) => {
    return (
      <div
        className={`flex items-center  ${
          columnObj.align === 'center'
            ? 'justify-center'
            : columnObj.align === 'left'
            ? 'justify-start'
            : `justify-end ${showEdit ? 'mr-8' : 'mr-4'}`
        }  space-x-4 text-white w-[${columnObj.minWidth}px]`}
      >
        <div className=" text-[14px]">{columnObj.label}</div>
        {sortArray?.includes(columnObj.id) && (
          <div className="cursor-pointer">
            {columnId == columnObj.id && sortOrder !== SortOrderType.ASC ? (
              <div onClick={() => sorting(columnObj, SortOrderType.DESC)}>
                <i
                  className={`fa-solid fa-arrow-up ${
                    columnId == columnObj.id && 'text-black'
                  }`}
                ></i>
              </div>
            ) : (
              <div onClick={() => sorting(columnObj, SortOrderType.ASC)}>
                <i
                  data-testid="sort-click"
                  className={`fa-solid fa-arrow-down ${
                    columnId == columnObj.id && 'text-black'
                  }`}
                ></i>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleCheckingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    if (name === 'allSelect') {
      const tempUser = state.map((item: any) => {
        return { ...item, isChecked: checked };
      });
      const selectedItems = tempUser
        .filter((data: any) => data.isChecked === true)
        .map((data: any) => data[`${checkBoxValue}`]);

      setIsSelected(selectedItems);
      setState(tempUser);
    } else {
      const tempUser = state.map((item: any) =>
        item[`${checkBoxValue}`] === name ? { ...item, isChecked: checked } : item
      );
      const selectedItems = tempUser
        .filter((data: any) => data.isChecked === true)
        .map((data: any) => data[`${checkBoxValue}`]);
      setIsSelected(selectedItems);
      setState(tempUser);
    }
  };
  const sorting = (column: any, order: string) => {
    setColumnId(column.id);
    onSortHandler?.(column.id, order);
  };
  const noDataMessage = () => {
    return (
      <div
        className={`space-x-4 shadow-lg rounded-sm ${colors.primaryText}  p-2 m-2 w-[300px] h-[60px] flex  items-center justify-center text-[20px] mt-2`}
      >
        <div>
          <i className="fa-solid fa-face-sad-tear"></i>
        </div>
        <div className="text-sm"> Sorry! No records found!</div>
      </div>
    );
  };
  return (
    <div data-testid="table-wrapper">
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          {/* <TableContainer> */}
          <Table stickyHeader aria-label="sticky table" align="left">
            <TableHead classes={{ root: styles.tableHead }}>
              <TableRow id={`table-row`}>
                {checkBoxShow && (
                  <TableCell
                    classes={{ root: styles.tableHeadCell }}
                    style={{ width: 10 }}
                    align="left"
                  >
                    <div className="cursor-pointer mt-2 ">
                      <input
                        type="checkbox"
                        name="allSelect"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleCheckingChange(e)
                        }
                        checked={
                          state.length > 0 &&
                          !state.some((user: any) => user?.isChecked !== true)
                        }
                        className="w-4 h-4 cursor-pointer"
                      />
                    </div>
                  </TableCell>
                )}
                {columns?.map((column: Column, index: number) => (
                  <TableCell
                    key={index}
                    align={column.align}
                    style={{ width: column.minWidth }}
                    classes={{ root: styles.tableHeadCell }}
                  >
                    {handleTableHeader(column)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.length > 0
                ? state?.map((row: any, index: number) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {checkBoxShow && (
                          <TableCell
                            key={index}
                            classes={
                              row?.isChecked
                                ? { root: styles.tablebodyWithChecked }
                                : { root: styles.tablebody }
                            }
                          >
                            <div className={`cursor-pointer`}>
                              <input
                                type="checkbox"
                                checked={row?.isChecked || false}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  handleCheckingChange(e)
                                }
                                name={row[`${checkBoxValue}`]}
                                className={`w-4 h-4 cursor-pointer `}
                              />
                            </div>
                          </TableCell>
                        )}
                        {columns?.map((column: Column, index: number) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index}
                              align={column.align}
                              style={{ width: column.minWidth }}
                              classes={
                                row?.isChecked
                                  ? { root: styles.tablebodyWithChecked }
                                  : { root: styles.tablebody }
                              }
                            >
                              {showItem(value, column, row)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : noDataMessage()}
            </TableBody>
          </Table>
        </TableContainer>
        {totalRowCount > 0 && state?.length > 0 && (
          <div className="m-4">
            <Pagination
              page={page}
              limit={limit}
              paginateHandler={paginateHandler}
              totalRowCount={totalRowCount}
            />
          </div>
        )}
      </Paper>
    </div>
  );
};
export default MuiTable;
